import getForm from "./form";

const {
  formField: { countryExport },
} = getForm();

const initialValues: Record<string, any> = {
  [countryExport.name]: [],
};

export default initialValues;
